import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { environment } from '../../../environments/environment';
import { UserService } from '../../services/user.service';
import { Subscription } from 'rxjs';
import { FirebaseStorageService } from '../../services/firebase-storage.service';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    TooltipModule,
    ToastModule
  ],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
  providers: [MessageService]
})
export class FooterComponent implements OnInit, OnDestroy {
  currentYear = new Date().getFullYear();
  appVersion = environment.version;
  isLoggedIn = false;
  isDownloading = false;
  isTestEnvironment = false;
  private subscription: Subscription = new Subscription();

  constructor(
    private userService: UserService,
    private firebaseStorageService: FirebaseStorageService,
    private messageService: MessageService
  ) { }

  ngOnInit(): void {
    // Controlla se siamo in ambiente di test o dev
    this.isTestEnvironment = environment.name === 'TEST' || environment.name === 'DEV';
    
    // Sottoscrizione reattiva allo stato di login
    this.subscription.add(
      this.userService.isLoggedIn$.subscribe(isLoggedIn => {
        this.isLoggedIn = isLoggedIn;
      })
    );
  }

  ngOnDestroy(): void {
    // Pulizia delle sottoscrizioni
    this.subscription.unsubscribe();
  }

  downloadChangelog() {
    if (this.isDownloading) return;

    try {
      this.isDownloading = true;
      const changelogPath = 'CHANGELOG_PMO.md';

      this.firebaseStorageService.downloadFile(changelogPath).subscribe({
        next: (blob: Blob) => {
          saveAs(blob, 'CHANGELOG_PMO.md');

        },
        error: (error: Error) => {
          console.error('Errore durante il download del changelog:', error);
          this.messageService.add({
            severity: 'error',
            summary: 'Errore',
            detail: 'Si è verificato un errore durante il download del changelog'
          });
        },
        complete: () => {
          this.isDownloading = false;
        }
      });
    } catch (error) {
      console.error('Errore durante il download del changelog:', error);
      this.messageService.add({
        severity: 'error',
        summary: 'Errore',
        detail: 'Si è verificato un errore durante il download del changelog'
      });
      this.isDownloading = false;
    }
  }
}
